module.exports = __webpack_public_path__ + "static/media/QL-Dollar-Two-Tone.5f586767.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/QL-Dollar-Two-Tone.svg
// module id = 247
// module chunks = 0